// App.js
import "./App.css";
import "./components/ui/ui.css";
import "./components/ui/actionbar.css";
import "./components/ui/filterbar.css";
import "./components/ui/dashboard.css";
import "./components/ui/stat-card.css";
import "./components/ui/table.css";
import "./components/ui/page-layout.css";
import React, { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
// import Home from './components/Home';
import Register from "./components/Register";
import AccountCreated from "./components/AccountCreated";
import VerifyEmail from "./components/VerifyEmail";
import ForgotPassword from "./components/ForgotPassword";
import CatalogOverview from "./components/CatalogOverview";
import EditCatalog from "./components/EditCatalog";
import AdminLogin from "./components/Admin/Auth/AdminLogin";
import UserLogin from "./components/UserLogin";
import AdminDashboard from "./components/Admin/AdminDashboard";
import AddCatalog from "./components/AddCatalog";
import InventoryPage from "./components/InventoryPage";
import SalesReports from "./components/SalesReports";
import ShipmentReportsPage from "./components/ShipmentReportsPage";
import Items from "./components/Items";
import AppsPage from "./components/AppsPage";
import Reports from "./components/Reports";
import ResetPassword from "./components/ResetPassword";
import PartnerSignIn from "./components/PartnerSignIn";
import PartnerSessionPage from "./components/PartnerSessionPage";
import PartnerSessionBanner from "./components/PartnerSessionBanner";
import Dashboard from "./components/Dashboard";
import Platforms from "./components/Platforms";
import Orders from "./components/Orders";
import Menu from "./components/Menu";
import Branches from "./components/Branches";
import Profile from "./components/Profile";
import MyAccountPage from "./components/account/MyAccountPage";
import SetupGuidePage from "./components/onboarding/SetupGuidePage";
import Setup2FA from "./components/Setup2FA";
import UserList from "./components/Admin/Users/UserList";
import StoreBranchOverview from "./components/StoreBranchOverview";
import AddNewStore from "./components/AddNewStore";
import AddNewBranch from "./components/AddNewBranch";
import ManageBranches from "./components/ManageBranches";
import ManageBranchesOld from "./components/ManageBranchesOld";
import AppManagement from "./components/AppManagement";
import SubscriptionPage from "./components/subscription/SubscriptionPage";
import AddApp from "./components/AddApp";
import AddOnIntegration from "./components/AddOnIntegration";
import ServiceIntermediaryPage from "./components/ServiceIntermediaryPage";
import TrackHubBranchesPage from "./components/trackhub/TrackHubBranchesPage";
import TrackHubReportsPage from "./components/trackhub/TrackHubReportsPage";
import CreateManualShipmentPage from "./components/trackhub/create-shipment/CreateManualShipmentPage";
import EditStore from "./components/EditStore";
import AdminAppManagement from "./components/Admin/AppManagement/AdminAppManagement";
import AdminAppManagementTable from './components/Admin/AppManagement/AdminAppManagementTable';

import AdminAddApp from "./components/Admin/AppManagement/AdminAddApp";
import AdminAddRoutes from "./components/Admin/AppManagement/AdminAddRoutes";
import AdminEditApp from "./components/Admin/AppManagement/AdminEditApp";
import ProductListing from "./components/ProductListing";
import AddProduct from "./components/AddProduct";
import AddItem from "./components/AddItem";
import AddCategory from "./components/AddCategory";
import CategoryOverview from "./components/CategoryOverview";
import Products from "./components/products";
import Product from "./components/product";
import Catalog from "./components/Catalog";
import UserManagement from "./components/UserManagement";
import CatalogDetails from "./components/CatalogDetails";
import ViewBranchPage from "./components/ViewBranchPage";
import ViewBranchPageV1 from "./components/ViewBranchPageV1";
import SystemLogs from "./components/Admin/SystemLogs/SystemLogs";
import ActivityLogs from "./components/Admin/ActivityLogs/ActivityLogs";
import AdminShipmentsPage from "./components/Admin/Shipments/AdminShipmentsPage";
import PrinterSettings from "./components/PrinterSettings";
import PrinterAddPage from "./components/PrinterAddPage";
import PrinterEditPage from "./components/PrinterEditPage";
import TopNavbar from "./components/TopNavbar";
import SideNavbar from "./components/SideNavbar";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeetaCallback from "./components/KeetaIntegration";
import TabSenseCallback from "./components/TabSenseIntegration";
import TermsCondition from "./components/TermsCondition";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { setupAxiosInterceptors, ensureValidSession } from "./services";
import { saveFlashMessage, showFlashMessage } from "./utils/flashMessage";
import "react-toastify/dist/ReactToastify.css";
import OrdersDisplay from "./components/OrdersDisplay";
import FoodicsRedirect from "./components/FoodicsRedirect";
import { OrderNotificationProvider } from "./contexts/OrderNotificationContext";
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import "@mantine/dates/styles.css";
import ViewOrderDetails from "./components/ViewOrderDetails";
import { PermissionProvider } from "./contexts/PermissionContext";
import RolesPage from "./components/rbac/RolesPage";
import { PermissionRoute } from "./components/rbac/PermissionRoute";


const RedirectToServicePage = () => {
  const { id } = useParams();
  return <Navigate to={`/services/${id}`} replace />;
};

// Wrapper component to restrict direct URL access to AddOnIntegration
const ProtectedAddOnIntegration = () => {
  return <AddOnIntegration />;
};
// Utility function to check if JWT token is expired
const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Date.now() / 1000; // Convert to seconds

    // Check if token has expired
    if (payload.exp && payload.exp < currentTime) {
      return true;
    }

    return false;
  } catch (error) {
    console.error("Error parsing token:", error);
    return true; // Consider invalid tokens as expired
  }
};

// Utility function to clear expired tokens
const clearExpiredTokens = () => {
  const token = localStorage.getItem("token");
  const adminToken = localStorage.getItem("adminToken");

  if (token && isTokenExpired(token)) {
    localStorage.removeItem("token");
    console.log("Expired user token removed");
  }

  if (adminToken && isTokenExpired(adminToken)) {
    localStorage.removeItem("adminToken");
    console.log("Expired admin token removed");
  }
};

const PrivateRoute = ({ children, adminOnly }) => {
  const { t } = useTranslation("translation");
  const location = useLocation();
  const { pathname, search } = location;
  const currentPath = pathname + search;

  clearExpiredTokens();

  const token = localStorage.getItem("token");
  const adminToken = localStorage.getItem("adminToken");
  const isAdminPath = pathname.startsWith("/admin");

  // --- ADMIN LOGIN PAGE ---
  if (pathname === "/admin/login" || pathname === "/") {
    if (adminToken && !isTokenExpired(adminToken)) {
      saveFlashMessage(`${t("You are already logged in as admin.")}`, "info");
      return <Navigate to="/admin/user-list" replace />;
    }
    if (token && !isTokenExpired(token)) {
      saveFlashMessage(`${t("You are not authorized to access admin login.")}`, "error");
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  }


  // --- USER TRYING TO ACCESS ADMIN ROUTE ---
  if (isAdminPath && token && !adminToken) {
    saveFlashMessage(`${t("You are not authorized to access.")}`, "error");
    return <Navigate to="/dashboard" replace />;
  }
  const activeRole = localStorage.getItem("active_role");

if (isAdminPath && pathname !== "/admin/login" && activeRole === "user") {
  saveFlashMessage(
    `${t("You are not authorized to access admin routes while impersonating a user.")}`,
    "error"
  );
  return <Navigate to="/dashboard" replace />;
}
  // --- ADMIN ROUTE AUTH ---
  if (isAdminPath && (!adminToken || isTokenExpired(adminToken))) {
    saveFlashMessage(`${t("Please login in to continue.")}`, "error");
    return (
      <Navigate
        to={`/admin/login?redirect=${encodeURIComponent(currentPath)}`}
        replace
      />
    );
  }

  if (!isAdminPath && (!token || isTokenExpired(token))) {
  // If admin is logged in but user token is missing
  if (adminToken && !isTokenExpired(adminToken)) {
    saveFlashMessage(`${t("You are not authorized to access.")}`, "error");
    return <Navigate to="/admin/user-list" replace />;
  }

  // Otherwise, treat it as a normal user session expiration
  saveFlashMessage(`${t("Please login to continue.")}`, "error");
  return (
    <Navigate
      to={`/?redirect=${encodeURIComponent(currentPath)}`}
      replace
    />
  );
}
  // --- USER ROUTE AUTH ---
if (!isAdminPath && (!token || isTokenExpired(token))) {
  saveFlashMessage(`${t("Please login to continue.")}`, "error");
  return (
    <Navigate
      to={`/?redirect=${encodeURIComponent(currentPath)}`}  // user login
      replace
    />
  );
}

  // --- ADMIN-ONLY RESTRICTION ---
  if (isAdminPath && adminToken) {
    try {
      const payload = JSON.parse(atob(adminToken.split(".")[1]));
      if (adminOnly && payload.user?.user_type !== "admin") {
        saveFlashMessage(`${t("You are not authorized to access this page.")}`, "error");
        return <Navigate to="/admin/user-list" replace />;
      }
    } catch (e) {
      console.error("Invalid admin token", e);
      saveFlashMessage(`${t("Your session is invalid. Please login again.")}`, "error");
      return <Navigate to="/admin/login" replace />;
    }
  }

  return children;
};

function UserProtected({ children }) {
  return (
    <PrivateRoute>
      <PermissionRoute>{children}</PermissionRoute>
    </PrivateRoute>
  );
}



function AppContent() {

  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    if (lastPath.current !== location.pathname) {
      // Only show once per path change
      showFlashMessage();
      lastPath.current = location.pathname;
    }
  }, [location.pathname]);
  const {i18n}= useTranslation("translation");
  const isArabic = i18n.language === 'ar';
   const navigate = useNavigate();

  useEffect(() => {
    const existingLink = document.getElementById('mdb-rtl-style');

    if (isArabic) {
      if (!existingLink) {
        const link = document.createElement('link');
        link.id = 'mdb-rtl-style';
        link.rel = 'stylesheet';
        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/7.1.0/mdb.rtl.min.css';
        document.head.appendChild(link);
      }
      document.documentElement.setAttribute('dir', 'rtl');
      document.documentElement.setAttribute('lang', 'ar');
    } else {
      if (existingLink) {
        existingLink.remove();
      }
      document.documentElement.setAttribute('dir', 'ltr');
      document.documentElement.setAttribute('lang', 'en');
    }
  }, [isArabic]);

  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  // New state for desktop collapse
  const [desktopSidebarCollapsed, setDesktopSidebarCollapsed] =
    React.useState(false);

  // Handler for mobile/tablet sidebar
  const handleSidebarToggle = () => setSidebarOpen((open) => !open);
  const handleSidebarClose = () => setSidebarOpen(false);

  // Handler for desktop sidebar collapse
  const handleDesktopSidebarToggle = () =>
    setDesktopSidebarCollapsed((prev) => !prev);

  // Add/remove scroll lock class on body
  React.useEffect(() => {
    if (sidebarOpen && window.innerWidth < 1024) {
      document.body.classList.add("sidebar-open");
    } else {
      document.body.classList.remove("sidebar-open");
    }
    return () => document.body.classList.remove("sidebar-open");
  }, [sidebarOpen]);

  const isTermsPage = location.pathname === "/terms-and-conditions";
  const isPartnerSession = location.pathname.startsWith("/partner-sessions/");
  const hideTopNav = [
    "/",
    "/register",
    "/account-created",
    "/forgot-password",
    "/reset-password",
    "/partner-sign-in",
    "/admin/login",
    "/terms-and-conditions",
    "/orders-display"

  ].some(
    (path) =>
      location.pathname === path ||
      location.pathname.startsWith("/reset-password") ||
      location.pathname.startsWith("/verify-email")
  );
  // Partner session keeps the Loops top bar (logo / lang / profile) but hides the sidebar.
  const hideSidebar = hideTopNav || isPartnerSession;
  const hideNav = hideSidebar;


// useEffect(() => {
//   const checkToken = () => {
//     const token = localStorage.getItem("token");
//     const adminToken = localStorage.getItem("adminToken");
//     const currentPath = window.location.pathname + window.location.search; // full path with query

//     console.log("🔎 [checkToken] Running check. Current path:", currentPath);

//     // ---- USER TOKEN ----
//     if (token && isTokenExpired(token)) {
//       console.log("⏰ [checkToken] User token expired. Clearing session.");
//       localStorage.removeItem("token");
//       localStorage.removeItem("user_type");
//       localStorage.removeItem("user");

//       console.log("➡️ [checkToken] Redirecting to login with redirect param:", currentPath);
//       navigate(`/?redirect=${encodeURIComponent(currentPath)}`, { replace: true });
//       return;
//     }

//     // ---- ADMIN TOKEN ----
//     if (adminToken && isTokenExpired(adminToken)) {
//       console.log("⏰ [checkToken] Admin token expired. Clearing session.");
//       localStorage.removeItem("adminToken");
//       localStorage.removeItem("adminUser");

//       console.log("➡️ [checkToken] Redirecting to admin login with redirect param:", currentPath);
//       navigate(`/admin/login?redirect=${encodeURIComponent(currentPath)}`, { replace: true });
//       return;
//     }

//     console.log("✅ [checkToken] Tokens still valid.");
//   };

//   // run immediately
//   checkToken();

//   // run every minute
//   const interval = setInterval(checkToken, 60 * 1000);

//   return () => clearInterval(interval);
// }, [navigate]);





  useEffect(() => {
    setupAxiosInterceptors(navigate);
    ensureValidSession().catch(() => {});
  }, [navigate]);
  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >

          {!hideTopNav && (
            <TopNavbar
              onSidebarToggle={handleSidebarToggle}
              onDesktopSidebarToggle={handleDesktopSidebarToggle}
              desktopSidebarCollapsed={desktopSidebarCollapsed}
              partnerSessionMode={isPartnerSession}
            />
          )}

        <div  className={`dashboard-layout ${isTermsPage ? "terms-page" : ""}${hideNav ? " dashboard-layout--auth" : ""}`}>
          {!hideSidebar && (
            <SideNavbar
              open={sidebarOpen}
              onClose={handleSidebarClose}
              desktopCollapsed={desktopSidebarCollapsed}
            />
          )}
          {/* Overlay should be rendered after the sidebar */}
          {sidebarOpen && !hideSidebar && (
            <div
              className="sidebar-overlay dashboard-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.3)",
                zIndex: 1999,
              }}
              onClick={handleSidebarClose}
            />
          )}
          <div className={`dashboard-content-scroll${hideNav ? " dashboard-content-scroll--auth" : ""}`}>
            <main className={`app-page-shell${hideNav ? " app-page-shell--auth" : ""}`}>
            <PartnerSessionBanner />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<UserLogin />} />
              <Route path="/register" element={<Register />} />
              <Route path="/account-created" element={<AccountCreated />} />
              <Route path="/verify-email/:token" element={<VerifyEmail />} />
              <Route path="/terms-and-conditions" element={<TermsCondition />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/reset-password/:token"
                element={<ResetPassword />}
              />
              <Route path="/partner-sign-in" element={<PartnerSignIn />} />
              <Route
                path="/partner-sessions/:id"
                element={
                  <UserProtected>
                    <PartnerSessionPage />
                  </UserProtected>
                }
              />
              <Route path="/admin/login" element={<AdminLogin />} />
              {/* Admin Dashboard */}
              <Route
                path="/admin/dashboard"
                element={
                  <PrivateRoute adminOnly>
                    <AdminDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/user-list"
                element={
                  <PrivateRoute adminOnly>
                    <UserList />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/available-apps"
                element={
                  <PrivateRoute adminOnly>
                    <AdminAppManagementTable />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/shipments"
                element={
                  <PrivateRoute adminOnly>
                    <AdminShipmentsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/add-app"
                element={
                  <PrivateRoute adminOnly>
                    <AdminAddApp />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/manage-routes/:appId"
                element={
                  <PrivateRoute adminOnly>
                    <AdminAddRoutes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/edit-app"
                element={
                  <PrivateRoute adminOnly>
                    <AdminEditApp />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/system-logs"
                element={
                  <PrivateRoute adminOnly>
                    <SystemLogs />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/activity-logs"
                element={
                  <PrivateRoute adminOnly>
                    <ActivityLogs />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/profile"
                element={
                  <PrivateRoute adminOnly>
                    <Profile />
                  </PrivateRoute>
                }
              />
              {/* Protected Routes */}
              <Route
                path="/dashboard"
                element={
                  <UserProtected>
                    <Dashboard />
                  </UserProtected>
                }
              />
              <Route
                path="/platforms"
                element={
                  <UserProtected>
                    <Platforms />
                  </UserProtected>
                }
              />
              <Route
                path="/orders"
                element={
                  <UserProtected>
                    <Orders />
                  </UserProtected>
                }
              />
                <Route
                path="/orders-display"
                element={
                  <UserProtected>
                    <OrdersDisplay />
                  </UserProtected>
                }
              />
              <Route
                path="/catalog-overview"
                element={
                  <UserProtected>
                    <CatalogOverview />
                  </UserProtected>
                }
              />
              <Route
                path="/category-overview"
                element={
                  <UserProtected>
                    <CategoryOverview />
                  </UserProtected>
                }
              />
              <Route
                path="/store&branches-overview"
                element={
                  <UserProtected>
                    <StoreBranchOverview />
                  </UserProtected>
                }
              />
              <Route
                path="/inventory"
                element={
                  <UserProtected>
                    <InventoryPage />
                  </UserProtected>
                }
              />
              <Route
                path="/products-listing"
                element={
                  <UserProtected>
                    <ProductListing />
                  </UserProtected>
                }
              />
              <Route
                path="/sales-reports"
                element={
                  <UserProtected>
                    <SalesReports />
                  </UserProtected>
                }
              />
              <Route
                path="/reports"
                element={
                  <UserProtected>
                    <Reports />
                  </UserProtected>
                }
              />
              <Route
                path="/shipment-reports"
                element={
                  <UserProtected>
                    <ShipmentReportsPage />
                  </UserProtected>
                }
              />
              <Route
                path="/catalog/items-list"
                element={
                  <UserProtected>
                    <Items />
                  </UserProtected>
                }
              />
              <Route
                path="/catalog/apps-list"
                element={
                  <UserProtected>
                    <AppsPage />
                  </UserProtected>
                }
              />
              <Route
                path="/orders/:orderId"
                element={
                  <UserProtected>
                    <ViewOrderDetails />
                  </UserProtected>
                }
              />
              <Route
                path="/apps-management"
                element={
                  <UserProtected>
                    <AppManagement />
                  </UserProtected>
                }
              />
              <Route
                path="/subscription"
                element={
                  <UserProtected>
                    <SubscriptionPage />
                  </UserProtected>
                }
              />
              <Route
                path="/user-management"
                element={
                  <UserProtected>
                    <UserManagement />
                  </UserProtected>
                }
              />
              {/* Roles UI: `_one_hub_frontend/src/components/rbac/RolesPage.js` (RBAC gated via UserProtected → PermissionRoute). */}
              <Route
                path="/rbac/roles"
                element={
                  <UserProtected>
                    <RolesPage />
                  </UserProtected>
                }
              />
              <Route
                path="/add-app/:id"
                element={
                  <UserProtected>
                    <AddApp />
                  </UserProtected>
                }
              />
              <Route
                path="/services/:id"
                element={
                  <UserProtected>
                    <ServiceIntermediaryPage />
                  </UserProtected>
                }
              />
              <Route
                path="/addon-intermediary/:id"
                element={
                  <UserProtected>
                    <RedirectToServicePage />
                  </UserProtected>
                }
              />
              <Route
                path="/addon-integration/:id"
                element={
                  <UserProtected>
                    <ProtectedAddOnIntegration />
                  </UserProtected>
                }
              />
              <Route
                path="/trackhub/:id"
                element={
                  <UserProtected>
                    <RedirectToServicePage />
                  </UserProtected>
                }
              />
              <Route
                path="/trackhub-integration/:id"
                element={
                  <UserProtected>
                    <TrackHubBranchesPage />
                  </UserProtected>
                }
              />
              <Route
                path="/shipments/new"
                element={
                  <UserProtected>
                    <CreateManualShipmentPage />
                  </UserProtected>
                }
              />
              <Route
                path="/shipments"
                element={
                  <UserProtected>
                    <TrackHubReportsPage />
                  </UserProtected>
                }
              />
              <Route
                path="/trackhub-reports/:id"
                element={<Navigate to="/shipments" replace />}
              />
              <Route
                path="/oauth/keeta/callback"
                element={
                  <UserProtected>
                    <KeetaCallback />
                  </UserProtected>
                }
              />
              <Route
                path="/oauth/tabsense/callback"
                element={
                  <PrivateRoute>
                    <TabSenseCallback />
                  </PrivateRoute>
                }
              />
                <Route
                path="/redirect-foodics"
                element={
                  <UserProtected>
                    <FoodicsRedirect />
                  </UserProtected>
                }
              />

              <Route
                path="/add-category"
                element={
                  <UserProtected>
                    <AddCategory />
                  </UserProtected>
                }
              />
              <Route
                path="/add-item"
                element={
                  <UserProtected>
                    <AddItem />
                  </UserProtected>
                }
              />
              <Route
                path="/add-product"
                element={
                  <UserProtected>
                    <AddProduct />
                  </UserProtected>
                }
              />
              <Route
                path="/edit-catalog"
                element={
                  <UserProtected>
                    <EditCatalog />
                  </UserProtected>
                }
              />
              <Route
                path="/add-catalog"
                element={
                  <UserProtected>
                    <AddCatalog />
                  </UserProtected>
                }
              />
              <Route
                path="/add-store"
                element={
                  <UserProtected>
                    <AddNewStore />
                  </UserProtected>
                }
              />
              <Route
                path="/edit-store"
                element={
                  <UserProtected>
                    <EditStore />
                  </UserProtected>
                }
              />
              <Route
                path="/add-branch"
                element={
                  <UserProtected>
                    <AddNewBranch />
                  </UserProtected>
                }
              />
              <Route
                path="/menu"
                element={
                  <UserProtected>
                    <Menu />
                  </UserProtected>
                }
              />
              <Route
                path="/branches"
                element={
                  <UserProtected>
                    <Branches />
                  </UserProtected>
                }
              />
              <Route
                path="/manage-branches-v2"
                element={
                  <UserProtected>
                    <ManageBranches />
                  </UserProtected>
                }
              />
              <Route
                path="/manage-branches"
                element={
                  <UserProtected>
                    <ManageBranchesOld />
                  </UserProtected>
                }
              />
              <Route
                path="/profile"
                element={
                  <UserProtected>
                    <Profile />
                  </UserProtected>
                }
              />
              <Route
                path="/my-account"
                element={
                  <UserProtected>
                    <MyAccountPage />
                  </UserProtected>
                }
              />
              <Route
                path="/setup-guide"
                element={
                  <UserProtected>
                    <SetupGuidePage />
                  </UserProtected>
                }
              />
              <Route
                path="/setup-2fa"
                element={
                  <UserProtected>
                    <Setup2FA />
                  </UserProtected>
                }
              />
              <Route
                path="/printer-settings"
                element={
                  <UserProtected>
                    <PrinterSettings />
                  </UserProtected>
                }
              />
              <Route
                path="/printer-settings/new"
                element={
                  <UserProtected>
                    <PrinterAddPage />
                  </UserProtected>
                }
              />
              <Route
                path="/printer-settings/:id/edit"
                element={
                  <UserProtected>
                    <PrinterEditPage />
                  </UserProtected>
                }
              />
              <Route
                path="/products"
                element={
                  <UserProtected>
                    <Products />
                  </UserProtected>
                }
              />
              <Route
                path="/product/:id"
                element={
                  <UserProtected>
                    <Product />
                  </UserProtected>
                }
              />
              <Route
                path="/catalog"
                element={
                  <UserProtected>
                    <Catalog />
                  </UserProtected>
                }
              />
              <Route
                path="/catalog/:id"
                element={
                  <UserProtected>
                    <CatalogDetails />
                  </UserProtected>
                }
              />
              <Route
                path="/view-branch"
                element={
                  <UserProtected>
                    <ViewBranchPage />
                  </UserProtected>
                }
              />
              <Route
                path="/view-branch-v1"
                element={
                  <UserProtected>
                    <ViewBranchPageV1 />
                  </UserProtected>
                }
              />
              {/* Catch-all for undefined routes */}
              <Route path="*" element={<h1>404 - Page Not Found</h1>} />
            </Routes>
            </main>
          </div>
        </div>
        {/* <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}
      </div>
    </>
  );
}

function App() {
  return (
    <MantineProvider>
      <Router>
        <PermissionProvider>
          <OrderNotificationProvider>
            <AppContent />
          </OrderNotificationProvider>
        </PermissionProvider>
      </Router>
    </MantineProvider>
  );
}

export default App;
